import React, { useCallback, useEffect, useState } from "react";

import * as audio from "./audio";

import { Room } from "./Room";
import { Soundwave } from "./Soundwave";

import "./BubbleApp.scss";

export const BubbleApp: React.FC = () => {
  let [started, setStarted] = useState(false);

  useEffect(() => {
    audio.init();
  }, []);

  let onMoveTo = useCallback((x: number, y: number, noiseCancel: boolean) => {
    audio.moveTo(x, y);
    audio.toggleCanceling(noiseCancel);
  }, []);

  return (
    <div className="bubbleApp">
      {started ? (
        <div className="bubbleAppContent">
          <Room
            onMoveTo={onMoveTo}
            onEnter={audio.enterRoom}
            onLeave={audio.leaveRoom}
          />
          <Soundwave />
          <Soundwave />
          <Soundwave />
        </div>
      ) : (
        <div className="intro">
          <p>Draw a circle inside the space to create a sound bubble</p>
          <button 
            className="button button--small button--auto"
            onClick={() => {
              audio.start();
              setStarted(true);
            }}
          >
            Begin
          </button>
        </div>
      )}
    </div>
  );
};
